import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ZoomOutIcon = function (_a) {
    var size = _a.size;
    return (_jsxs("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("circle", { cx: "11", cy: "11", r: "8" }), _jsx("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" }), _jsx("line", { x1: "8", y1: "11", x2: "14", y2: "11" })] }));
};
